export enum END_TRIAL_MODAL_TRACK_EVENTS {
  MODAL_SHOWN = 'end_trial_modal_shown',
  MODAL_DISMISSED = 'end_trial_modal_dismissed',
  CONTACT_US_CLICKED = 'end_trial_modal_contact_us_clicked',
  UPGRADE_NOW_CLICKED = 'end_trial_modal_upgrade_now_clicked',
}
